import { type FC, type PropsWithChildren } from 'react'

import { TakeoverUnifiedBoxBase } from '@/components-page/advertisement/TakeoverUnifiedBoxBase'
import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const TakeoverUnifiedBox: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(HOMEPAGE_GPT_ID.TAKEOVER)

  return (
    <TakeoverUnifiedBoxBase hasTakeover={hasTakeover} background="#fff">
      {children}
    </TakeoverUnifiedBoxBase>
  )
}
